import { render, staticRenderFns } from "./recipe.vue?vue&type=template&id=34bc6c56&"
import script from "./recipe.vue?vue&type=script&lang=js&"
export * from "./recipe.vue?vue&type=script&lang=js&"
import style0 from "./recipe.vue?vue&type=style&index=0&id=34bc6c56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports